import { mapState, mapGetters, mapActions } from 'vuex'

export const reservationComputed = {
  ...mapState('reservation', {}),
  ...mapGetters('reservation', [
    'getListBooking',
    'getTotalPage',
    'sendMailBooking',
    'sendMailBookingSuccess',
    'getIsLoading',
    'getCurrentChangePage',
  ]),
}

export const reservationMethods = mapActions('reservation', [
  'getListBookingDetail',
  'sendMailListBooking',
  'setCurrentPage',
])
